module.exports = __webpack_public_path__ + "img/logo-mrclick.1ab2009b.png";